/**
 * Validates a post-login "return to" target (browser side).
 *
 * Mirror of server/api-util/safeReturnPath.js — the rules are identical and a
 * parity test (server/api-util/safeReturnPath.test.js) runs the same vectors
 * through both. See that file for what is refused and why.
 */

export const MAX_LENGTH = 2048;
const INTERNAL_ORIGIN = 'http://internal.invalid';
const FORBIDDEN = /[\u0000- \u007f\\]/;

/**
 * @param {*} value candidate return target
 * @param {string|null} [fallback] returned when the value is not acceptable
 * @returns {string|null} a safe internal path (pathname + search + hash) or the fallback
 */
export const sanitizeReturnPath = (value, fallback = null) => {
  if (typeof value !== 'string') return fallback;
  if (value.length === 0 || value.length > MAX_LENGTH) return fallback;
  if (FORBIDDEN.test(value)) return fallback;
  if (value[0] !== '/' || value[1] === '/') return fallback;

  let url;
  try {
    url = new URL(value, INTERNAL_ORIGIN);
  } catch (e) {
    return fallback;
  }
  if (url.origin !== INTERNAL_ORIGIN) return fallback;

  const normalised = `${url.pathname}${url.search}${url.hash}`;
  if (normalised.startsWith('//') || normalised[0] !== '/') return fallback;
  if (/^\/api(\/|$|\?|#)/i.test(normalised)) return fallback;
  return normalised;
};
